import { Typography } from "@mui/material"
import { ModelOutSideDto } from "api"
import { useIsDesktop } from "common/MediaQueries"
import NextImage from "common/bit/NextImage"
import RoundSliderIcon from "reusable/icons/RoundSliderIcon"
import styled from "styled-components"
import { ComparisonSlider } from "./ComparisonSlider"
const StyledSectionWrapper = styled.div`
  overflow: hidden;
  width: 100vw;
`
const StyledWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: ${(p) => p.theme.colors.darkGrey};
`
const StyledGradientOverlay = styled.div<{ $dark?: boolean }>`
  position: absolute;
  bottom: 0px;
  left: 0;
  background: ${(p) =>
    p.$dark
      ? "linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 25.42%)"
      : "linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 28.33%)"};
  width: 100%;
  height: 100%;
`
const StyledText = styled(Typography).attrs({ variant: "h2" })<{
  $dark?: boolean
}>`
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0;
  color: ${(p) => (p.$dark ? p.theme.colors.white : p.theme.colors.black)};
  margin-bottom: 120px;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 28px;
  }
`
const StyledDivider = styled.div`
  width: 2px;
  height: 100%;
  background-color: ${(p) => p.theme.colors.white};
`
type ModelComparisonSliderProps = {
  data: ModelOutSideDto
}

const ModelComparisonSlider = ({ data }: ModelComparisonSliderProps) => {
  const isDesktop = useIsDesktop()
  return (
    <StyledSectionWrapper role="region" aria-label="גלריית תמונות">
      <ComparisonSlider
        defaultValue={70}
        itemOne={
          <StyledWrapper>
            <NextImage
              image={{
                imageUrl: isDesktop
                  ? data?.frontCurtain?.desktopImageUrl
                  : data.frontCurtain.mobileImageUrl,
                alt: data?.frontCurtain?.alt,
              }}
            />
            {data?.backCurtain?.name && <StyledGradientOverlay $dark />}
            <StyledText $dark>{data?.frontCurtain?.name}</StyledText>
          </StyledWrapper>
        }
        itemTwo={
          <StyledWrapper>
            <NextImage
              image={{
                imageUrl: isDesktop
                  ? data?.backCurtain?.desktopImageUrl
                  : data.backCurtain.mobileImageUrl,
                alt: data?.backCurtain?.alt,
              }}
            />
            {data?.backCurtain?.name && <StyledGradientOverlay />}
            <StyledText>{data?.backCurtain?.name}</StyledText>
          </StyledWrapper>
        }
        handleAfter={<StyledDivider />}
        handleBefore={<StyledDivider />}
        aspectRatio={null}
        height={isDesktop ? "100vh" : "90vh"}
        orientation="horizontal"
        onlyHandleDraggable={true}
        handle={() => {
          {
            return <RoundSliderIcon />
          }
        }}
      />
    </StyledSectionWrapper>
  )
}

export default ModelComparisonSlider
